import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200 bg-slate-50 p-3"
};
const _hoisted_2 = {
  class: "mb-2 flex items-center justify-between gap-3"
};
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_4 = {
  class: "flex items-center justify-between gap-2"
};
const _hoisted_5 = {
  key: 0,
  class: "text-xs font-medium text-primary-600"
};
const _hoisted_6 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-1.5"
};
import { computed } from 'vue';
export default {
  __name: 'InvoiceCustomerTagSelect',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const enabledTags = computed(() => [...(props.tags || [])].filter(tag => tag?.enabled !== false).sort((left, right) => {
      const leftOrder = Number(left?.displayOrder || 0);
      const rightOrder = Number(right?.displayOrder || 0);
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;
      return String(left?.tagName || '').localeCompare(String(right?.tagName || ''), 'zh-CN');
    }));
    const selectedTags = computed(() => {
      const selected = new Set(props.modelValue.map(value => String(value)));
      return enabledTags.value.filter(tag => selected.has(String(tag.id)));
    });
    function normalizeTagIds(value) {
      return Array.isArray(value) ? value.filter(item => item !== null && item !== undefined && item !== '') : [];
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", null, [_createElementVNode("div", {
        class: "form-label"
      }, "企业标签"), _createElementVNode("p", {
        class: "mt-0.5 text-xs text-slate-500"
      }, "用于下游标签偏好的软匹配。")], -1)), __props.loading ? (_openBlock(), _createElementBlock("span", _hoisted_3, "加载中...")) : _createCommentVNode("", true)]), _createVNode(_component_el_select, {
        "model-value": __props.modelValue,
        multiple: "",
        filterable: "",
        clearable: "",
        "collapse-tags": "",
        "collapse-tags-tooltip": "",
        "max-collapse-tags": 3,
        class: "w-full bg-white",
        placeholder: "选择企业标签",
        disabled: __props.disabled || __props.loading,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => emit('update:modelValue', normalizeTagIds($event)))
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledTags.value, tag => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: tag.id,
            label: tag.tagName,
            value: tag.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(tag.tagName), 1), __props.modelValue.includes(tag.id) ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已选")) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["model-value", "disabled"]), selectedTags.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, tag => {
        return _openBlock(), _createElementBlock("span", {
          key: tag.id,
          class: "data-table-inline-tag"
        }, _toDisplayString(tag.tagName), 1);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
};